import { atom } from 'jotai';

export interface LocationFormState {
  facilityName: string;
  facilityGroupId?: string;
  facilityType: string;
  timezone: string;
  address: {
    streetAddress: string;
    addressLine2?: string;
    country: string;
    postalCode: string;
    city: string;
    state: string;
  };
  phone?: string;
  email?: string;
}

const initialState: LocationFormState = {
  facilityName: '',
  facilityGroupId: undefined,
  facilityType: '',
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  address: {
    streetAddress: '',
    addressLine2: undefined,
    country: '',
    postalCode: '',
    city: '',
    state: '',
  },
  phone: undefined,
  email: undefined,
};

export const $locationForm = atom<LocationFormState>(initialState);

export const $updateLocationForm = atom(
  null,
  (get, set, update: Partial<LocationFormState>) => {
    const currentState = get($locationForm);
    set($locationForm, {
      ...currentState,
      ...update,
      address: {
        ...currentState.address,
        ...(update.address ?? {}),
      },
    });
  },
);

export const $resetLocationForm = atom(null, (get, set) => {
  set($locationForm, initialState);
});
